import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROLE_TYPES } from '@/constants/constants.js';
import {
  canUseProductionAutomation,
} from '@/features/automation/utils/productionAccess.js';

function MenuItem({ icon, label, onClick, isLogout }) {
  return (
    <div
      className={`menu-item ${isLogout ? 'logout-item' : ''}`}
      onClick={onClick}
    >
      <i className={`bi ${icon}`}></i>
      <span>{label}</span>
    </div>
  );
}

function buildMenuItems({ roleId, handleNavigate, handleLogout }) {
  const canUseVideoProduction = canUseProductionAutomation(roleId);
  const isAdmin = roleId === ROLE_TYPES.管理员;

  const items = [
    {
      icon: 'bi-card-list',
      label: '订单列表',
      action: () => handleNavigate('/clients'),
    },
    {
      icon: 'bi-file-earmark-spreadsheet',
      label: '订单结算',
      action: () => handleNavigate('/bills'),
    },
  ];

  if (canUseVideoProduction) {
    items.push(
      { divider: true },
      {
        icon: 'bi-camera-video',
        label: '阿里云视频',
        action: () => handleNavigate('/automation/video-editing/list'),
      },
      {
        icon: 'bi-film',
        label: '剪映视频',
        action: () => handleNavigate('/automation/jianying/list'),
      },
    );
  }

  items.push({ divider: true });

  if (isAdmin) {
    items.push(
      {
        icon: 'bi-gear',
        label: '系统管理',
        action: () => handleNavigate('/system-management'),
      },
      { divider: true },
    );
  }

  items.push({
    icon: 'bi-box-arrow-right',
    label: '登出',
    action: handleLogout,
    isLogout: true,
  });

  return items;
}

function UserDropdownMenu({ role_id, onClose }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    onClose();
    navigate('/');
  };

  const handleNavigate = (path) => {
    onClose();
    navigate(path);
  };

  const roleId = Number(role_id);
  const menuItems = buildMenuItems({ roleId, handleNavigate, handleLogout });

  return (
    <div className="user-dropdown-menu">
      {menuItems.map((item, index) =>
        item.divider ? (
          <div key={`divider-${index}`} className="menu-divider"></div>
        ) : (
          <MenuItem
            key={item.label}
            icon={item.icon}
            label={item.label}
            onClick={item.action}
            isLogout={item.isLogout}
          />
        ),
      )}
    </div>
  );
}

export default UserDropdownMenu;
